module.exports = __webpack_public_path__ + "static/media/instagram-white.9b2ad966.svg";